import * as _ from 'lodash';
// TODO: Finish billing code validation
// import ErrorResponse from 'src/models/ErrorResponse';
import React, { useEffect, useState } from 'react';
import InvoiceType from 'src/models/InvoiceType';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
// import { FaTrash } from 'react-icons/fa';
// import { MdHistory } from 'react-icons/md';
// import State from 'src/models/State';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
// import ReceiptDocs from './ReceiptDocs';
import Voucher from 'src/models/AP/VoucherMaintenanceForm';
import Expense from 'src/models/AP/Expense';
import * as Constants from 'src/components/common/Constants';
// import DefineBudgetCategoryDialog from '../dialogs/DefineBudgetCategoryDialog';
// import FindVendorDialog from '../dialogs/FindVendorDialog';
// import AddVendorInvoicesDialog from '../dialogs/AddVendorInvoicesDialog';
import PagedResultSet from 'src/models/common/PagedResultSet';
// import WarningDialog from '../dialogs/WarningDialog';
import ReportOptionsDialog from 'src/components/accounts-payable/dialogs/ReportOptionsDialog';
// import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
// icons
// import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { MdHistory } from 'react-icons/md';
import { FaHistory } from 'react-icons/fa';
import { FaRegEdit  } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
// import ChooseVouchersDialog from '../dialogs/ChooseVouchersDialog';
// import ExcelFileDialog from '../dialogs/ExcelFileDialog';
// import EnterCheckNumberDialog from '../dialogs/EnterCheckNumberDialog';
// import CreateCheckWarningDialog from '../dialogs/CreateCheckWarningDialog';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
// import Account from 'src/models/Account';
// import VoidVoucherDialog from '../dialogs/VoidVoucherDialog';
// import OutputDestinationDialog from '../dialogs/OutputDestinationDialog';
import VendorInvoice from 'src/models/AP/VendorInvoice'; 
// import AddVendorExDialog from '../dialogs/AddVendorExDialog';
import { ITableConfig } from 'src/components/common/table';
import CPNavBar from '../CPNavBar';
import FindProjectDialog from '../dialogs/FindProjectDialog';
import TsdiClient from 'src/models/AP/Client';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import 'react-datepicker/dist/react-datepicker.css';
import './ClientMaintenancePage.scss';
import InvoiceTypeList from 'src/components/project/sections/InvoiceTypeList';
import ProjectBilling from 'src/models/projectSettings/ProjectBilling';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import FindManagerDialog from 'src/components/project-billing/dialogs/FindManagerDialog';
import Landman from 'src/models/Landman';
import { AiOutlineFileText } from 'react-icons/ai'; // Ant Design

const ManageProjectBilling = () => {
    const dispatch = useDispatch();
    const [invoiceTypeList, setInvoiceTypeList] = useState<InvoiceType[]>([]);
    const [project, setProject] = useState<ProjectBilling>(undefined);
    const { get, put, post, response } = useFetch();
    const [selectedInvoiceTypes, setSelectedInvoiceTypes] = useState<InvoiceType[]>([]);
    const { register, setValue, getValues, handleSubmit, errors, control } = useForm();
    const { reset: resetSelectedProject, register: registerSelectedProject, getValues: getValuesSelectedProject} = useForm();
    const { register: registerProjectBillingForm, reset: resetProjectBillingForm, formState: formStateProjectBillingForm, getValues: getValuesProjectBillingForm} = useForm();
    // const { register: registerClientInfoFormSection2, reset: resetClientInfoFormSection2, getValues: getValuesClientInfoFormSection2, formState: formStateClientInfoFormSection2 } = useForm();
    const [voucherIndex, setVoucherIndex] = useState<number>(-1);
    const [voucherInvoices, setVoucherInvoices] = useState<Array<VendorInvoice>>(undefined);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const [clientInfo, setClientInfo] = useState<TsdiClientInfo>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [vouchers, setVouchers] = useState<PagedResultSet<Voucher>>(undefined);
    const [voucherAccounts, setVoucherAccounts] = useState<Array<Expense>>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [clientTypes, setClientTypes] = useState<{ code: number, description: string}[]>([]);
/*     const [mealreceiptsrequired, setMealreceiptsrequired] = useState<boolean>(false);
    const [ndaRequired, setNdaRequired] = useState<boolean>(false);
    const [masterServicesAgreementRequired, setMasterServicesAgreementRequired] = useState<boolean>(false);
    const [subConsultantAgreementRequired, setSubConsultantAgreementRequired] = useState<boolean>(false);
    const [noGiftPolicy, setNoGiftPolicy] = useState<boolean>(false);
    const [workOrderRequired, setWorkOrderRequired] = useState<boolean>(false);   */
    const [voucherSearchOptions, setVoucherSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [addingProject, setAddingProject] = useState<boolean>(false);
    const [fetchNextVouchersPage, setFetchNextVouchersPage] = useState<boolean>(true);
    const { isDirty: isDirtyProjectBillingForm } = formStateProjectBillingForm;
    const [tsdiAccounts, setTsdiAccounts] = useState<Array<{ code: number, description: string}>>(undefined);
    const [billByOptions, setBillByOptions] = React.useState<Array<{ value: number, label: string}>>(undefined);
    const [managers, setManagers] = useState<Landman[]>(undefined);
    // const { isDirty: isDirtyClientInfoFormSection2 } = formStateClientInfoFormSection2;
    // TODO: Finish billing code validation
    // const [timeAndExpenseToken, setTimeAndExpenseToken] = useState<string>('');
    // const [clientValidations, setClientValidations] = useState<Array<boolean>>([]);

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clients) {
            const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
            if (!!storedClientNumber && !isNaN(Number(storedClientNumber))) {
                const clientToSelect = clients.find((c) => c.clientNumber === Number(storedClientNumber));
                if (!!clientToSelect) {
                    setSelectedClient(clientToSelect);
                }
            }
        }
    }, [clients]);

    useEffect(() => {
        if (!!clientInfo) {
            console.log('ClientInfo loaded logic goes here.');
            if (!!selectedProject?.id) {
                getProjectBillingInfo(selectedProject.id);
            }
        }
    }, [clientInfo]);

    useEffect(() => {
        if (!!project) {
            populateProjectBillingForm();
        }
    }, [project]);

    useEffect(() => {
        if (!!addingProject) {
            showDialog(DialogList.FIND_PROJECT);
        }
    }, [addingProject]);

    useEffect(() => {
        if (!!selectedProject) {
            const formValues = getValuesSelectedProject();
            console.log(formValues);
            resetSelectedProject({ displayProjectNumber: selectedProject?.number, displayProjectName: selectedProject?.name });
            loadData();
        }
    }, [selectedProject]);

    useEffect(() => {
        if (!!selectedClient) {
            getClientInfo(selectedClient?.clientNumber);
            if (!!clients && clients?.length > 0) {
                if (selectedClient !== undefined) {
                    const storedProjectNumber = localStorage.getItem('backOfficeSelectedProjectNumber');
                    const storedProjectName = localStorage.getItem('backOfficeSelectedProjectName');
                    if (!!storedProjectNumber && !isNaN(Number(storedProjectNumber)) && !!storedProjectName) {
                        getProject(selectedClient.clientNumber, Number(storedProjectNumber));
                    }
                }
            }
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        // normalizeBlankRows();
        if (!!voucherAccounts && voucherAccounts?.length > 0 && !!vouchers && vouchers?.items?.length > 0) {
            calculateTotal();
            // setClientValidations(new Array<boolean>(voucherAccounts?.length).fill(true));

            // index 3 is the 1st non-blank entry. 99000 - 100000 means it's a blank entry. > 100000 means it's a new unsaved entry.
            if (voucherAccounts.length > 3 && voucherAccounts[3]?.accountId < Constants.accountsPayableVoucherAccountsBlankAccountsBase) {
                getAccountInfo(vouchers?.items[voucherIndex]?.voucherNumber, voucherAccounts[3]?.accountNumber);
            }
/*             voucherAccounts.forEach((va, index) => {
                if (!!va?.clientNumber && va?.accountId >= Constants.accountsPayableVoucherAccountsUnsavedAccountsBase) {
                    getClient(voucherAccounts[index].clientNumber, index);
                }
            }); */
        }
    }, [voucherAccounts]);

    useEffect(() => {
        if (!!voucherInvoices && voucherInvoices?.length > 0) {
            if (!!vouchers && !!vouchers.items[voucherIndex]?.vendorNumber) {
                voucherInvoices[0].vendorNumber = vouchers.items[voucherIndex]?.vendorNumber.toString();
            }
        }
    }, [voucherInvoices]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!voucherSearchOptions) {
            getVouchers();
        }
    }, [voucherSearchOptions]);

    const populateProjectBillingForm = () => {
        const billingForm = {
            dayRate: project.dayRate,
            mileageRate: project.mileageRate,
            billBy: project.billByMethod,
            printPreparedDate: project.printPreparedDate,
            invoiceDueDays: project.invoiceDueDays,
            backupOfficeRate: project.backupOfficeRate,
            backupOfficePercent: project.chargeBpPercentage,
            currentInstructions: project.currentInstructions
        };

        resetProjectBillingForm(billingForm as Partial<ProjectBilling>);
        resetSelectedProject({ displayProjectNumber: selectedProject?.number, displayProjectName: selectedProject?.name });
    };

    const getBillbyOptions = async () => {
        const result = await get(`/v1.0/ClientProjectMaintenance/billing/billby/options`);

        if (response.ok) {
            if (!!result && result.length > 0) {
                setBillByOptions(result?.map((bbo: { code: number, description: string}) => {
                    return { value: bbo.code, label: bbo.description };
                }));
            }
        }
    };

    const getProject = async (clientNumber: number, projectNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectNumber}/client/${clientNumber}`);

        if (response.ok) {
            setSelectedProject(result);
        }
    };

    const getClientInfo = async (clientNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/info/${clientNumber}`);

        if (response.ok) {
            setClientInfo(result);
        } else {
            setClientInfo(new TsdiClientInfo());
            console.log('Unable to get client info data!');
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const getInvoiceTypes = async () => {
        const result = await get(`/v1.0/clients/${selectedClient}/projects/${1}/invoice/invoice-types`);

        if (response.ok) {
            setInvoiceTypeList(result);
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

/*     const addClient = async (payload: Client) => {
        let result = await post(`/v1.0/AccountsPayable/clients`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    }; */

    const updateProjectBillingInfo = async (data: ProjectBilling) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/client/info`, data);

        if (!response.ok) {
            alert('Unable to update client info data: ' + result);
        } else {
            setSelectedClient(selectedClient);
        }
    };

    const handleReport = () => {
        reportOptions();
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const incrementClients = () => {
        if (!!fetchNextPage) {
            let newSearchOptions = _.cloneDeep(clientSearchOptions);
            newSearchOptions.incrementPageNumber();
            setClientSearchOptions(newSearchOptions);
        }
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        getBillbyOptions();
        const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
        const storedClientName = localStorage.getItem('backOfficeSelectedClientName');
        getInvoiceTypes();
        setAddingProject(false);
        if (!!storedClientNumber && !isNaN(Number(storedClientNumber)) && !!storedClientName) {
            setClientSearchTerm(storedClientNumber);
        } else {
            getClients();
        }
        getClientTypes();
        getBillingAccounts();
        initializeClientSearchSettings();
        getCurrentMileageRate();
    };

    const getProjectBillingInfo = async (projectId: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/billing/info/project/${projectId}`);
        setProject(new ProjectBilling());
        if (response.ok) {            
            setProject(result);
        }
    };

    const AddProjectAndHideDialog = (payload: ProspectDetails) => {
        addProject(payload);
        hideDialog();
    };

    const addProject = async (payload: ProspectDetails) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok) {            
            getProjectBillingInfo(result);
        }
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        setAddingProject(false);
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        setAddingProject(false);
        dispatch(actions.layout.hideDialog());
    };

    const calculateTotal = () => {
        let formVoucherAccounts = getValues()?.voucherAccounts;
        let voucherAccountTotal = 0;
        if (formVoucherAccounts?.length) {
            for (let voucherAccountIndex = 0; voucherAccountIndex < voucherAccounts?.length; voucherAccountIndex++) {
                if (!!formVoucherAccounts[voucherAccountIndex]?.amount) {
                    voucherAccountTotal += parseFloat(formVoucherAccounts[voucherAccountIndex]?.amount + '');
                }
            }

            setValue('total', voucherAccountTotal);
            setValue('currentVoucherMaintenanceForm.voucherAmount', voucherAccountTotal);
        }
    };

/*     const displayWarning = (index: number) => {
        setSelectedIndividualIndex(index);
        showDialog(DialogList.WARNING);
    };

    const displayVoidWarning = () => {
        setVoidingVoucher(true);
        showDialog(DialogList.WARNING);
    }; */

    const onSubmit = async (data: Voucher) => {
        if (!!data) {
            let finalData = finalizeData(data);
            console.log(finalData);
        }
    };

    const finalizeData = (data: Voucher) => {
        // Get all the form values, then add in the Personnel model values that the form doesn't have
        let finalData: Voucher = {
            ...data,
        };

        return finalData;
    };

    const getVouchers = async () => {
        let result = await get(`/v1.0/AccountsPayable/vouchers${voucherSearchOptions?.toString()}`);

        if (response.ok) {
            if (voucherSearchOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(vouchers);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setVouchers(tempResult);
            } else {
                setVouchers(result);
            }
            setFetchNextVouchersPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get voucher data!!!');
        }
    };

    const getVoucherInvoices = async (voucherNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/voucher/voucherNumber/${voucherNumber}/invoices`);

        if (response.ok) {
            setVoucherInvoices(result);
        } else {
            console.log('Unable to get voucher Data!');
        }
    };

    const getBlankExpenseRows = (numberOfRows: number) => {
        let blankExpenseRows = [];
        let blankExpenseRowAaccountId = Constants.accountsPayableVoucherAccountsBlankAccountsBase;
        for (let blankRows = 0; blankRows < numberOfRows; blankRows++) {
            let blankExpenseRow = new Expense();
            blankExpenseRow.billingAccount = '1';
            blankExpenseRow.clientNumber = 90;
            blankExpenseRow.projectNumber = 1;
            blankExpenseRow.accountId = blankExpenseRowAaccountId++;
            blankExpenseRows.push(blankExpenseRow);
        }

        return blankExpenseRows;
    };

    const getVoucherAccounts = async (voucherNumber: string) => {
        // setVoucherAccounts([]);
        let result = await get(`/v1.0/AccountsPayable/voucheraccounts/voucherNumber/${voucherNumber}`);

        let newVoucherAccounts: Expense[] = [];
        if (response.ok && result?.items?.length > 0) {
            newVoucherAccounts = [...newVoucherAccounts].concat([...result?.items]);
        } else {
            console.log('Unable to get voucher accounts Data!');
        }
        let baseVoucherAccounts: Expense[] = [];
        baseVoucherAccounts = [...getBlankExpenseRows(3)];
        setVoucherAccounts(newVoucherAccounts.concat([...baseVoucherAccounts]));
    };

    const getAccountInfo = async (voucherNumber: string, glAccountNumber: string) => {
        let result = await get(`/v1.0/AccountsPayable/accountinfo/voucherNumber/${voucherNumber}/glAccountNumber/${glAccountNumber}`);

        if (response.ok) {
            console.log('Got voucher Data!' + result);
        } else {
            console.log('Unable to get voucher Data!');
        }
    };

    // TODO: Finish billing code validation
    /*
    const getClient = async (clientNumber: number, index: number) => {
        let options = new ODataOptions();
        options.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, clientNumber));
        let result = await get(`/v1.0/AccountsPayable/client${options.toString()}`);

        let newClientVerifications = _.cloneDeep(clientValidations);
        if (response.ok) {
            if (!!result.clientNumber) {
                newClientVerifications.splice(index, 1, !!result.clientNumber ? true : false);
            }
        } else {
            newClientVerifications.splice(index, 1, false);
        }
        setClientValidations(newClientVerifications);
    };

     const getClients = async () => {
        let result = await get(`/v1.0/AccountsPayable/clients`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const handleApiError = (value: Response) => {
        console.log('api call failed: ' + value);
    };

    const handleApiCall = (value: Response) => {
        return new Promise<object>((resolve) => {
            if (value.ok) {
                value
                    .json()
                    .then((body) => resolve(body))
                    .catch(() => resolve(null));
            } else {
                resolve(value.json().then((errorResponse: ErrorResponse) => new ErrorResponse(errorResponse.messageCode, errorResponse.message)));
            }
        });
    };

    const getJwtToken = (): string => {
        return timeAndExpenseToken;
    };

    const createHeader = (type: string) => {
        let headers = {};

        // let jwtToken = getJwtToken();
        // jwt = undefined;

        const username = `Joe Example`;
        const password = `DudleyRocks025!`;
        if (type === 'jwt') {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                // 'Connection': 'keep-alive',
                // 'content-type': 'application/json',
                // Authorization: `Bearer ${jwt}`,
            };
        } else if (type === 'validateProspect') {
            headers =  {
                'Tsjwt': timeAndExpenseToken,
                'content-type': 'application/json'
              };
        } else {
            headers = {
                'un': `${username}`,
                'pw': `${password}`,
                'content-type': 'application/json' };
        }

        return headers;
    };

    const getHeader = (jwt: string | undefined) => {
        const header: RequestInit = {
            headers: createHeader(jwt),
            method: 'GET',
            mode: 'cors',
        };
        return header;
    };

    const postHeader = (body: object, jwt: string | undefined = undefined) => {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: createHeader('validateProspect'),
            method: 'POST',
            mode: 'cors',
        };
        return header;
    };

    const getRequest = async (url: string, jwt: string | undefined = undefined) => {
        return fetch(url, getHeader(jwt)).then(handleApiCall).catch(handleApiError);
    };

    const postRequest = async (url: string, body: object, jwt: string | undefined = undefined) => {
        return fetch(url, postHeader(body, jwt)).then(handleApiCall).catch(handleApiError);
    };

    const baseCalmsServicesUrl = `https://services.calms.net`;
    const baseTandEUrl = `https://time.calms.net`;

    // https://services.calms.net/api/tokenissue

    const getTEUserToken = async () => {
        const result = await getRequest(`${baseCalmsServicesUrl}/api/tokenissue`, 'jwt');
        setTimeAndExpenseToken((result as {timeAndExpenseJwt: string}).timeAndExpenseJwt);
    }; */

    // TODO: Finish billing code validation
/*     const validateBillingCode = async (index: number) => {
        const formValues = getValues();
        console.log(index + ' ' + formValues);
        const payload = {
            'clientNumber': `${formValues.voucherExpenses[index].clientNumber}`,
            'prospectNumber': `${formValues.voucherExpenses[index].projectNumber}`,
            'sectionNumber': 0,
            'unitNumber': 0};
        let data = await postRequest(`${baseTandEUrl}/api/entry/validateProspect`, payload as object, 'validateProspect');
        if (response.ok && (!(data as {error: string})?.error || (data as {error: string})?.error?.length === 0)) {
            console.log('========> Received response from T&E Service', data);
        } else {
            let newClientVerifications = _.cloneDeep(clientValidations);
            newClientVerifications.splice(index, 1, false);
            // let newClientValidations = [];
            // newClientValidations.push({index: index, error: true});
            setClientValidations(newClientVerifications);
            const errorText = (data as {error: string})?.error;
            console.log('Unable to validate billing code.' + errorText);
            const errorTextElement = document.getElementById('BillingCodeError');
            errorTextElement.innerText = errorText;
            errorTextElement.setAttribute('style', 'display: block; color: red');
        }
    }; */

    const getClients = async () => {
        const queryString = !!clientSearchOptions ? clientSearchOptions?.toString() : '';
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);

        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);

        if (response.ok) {
            setClientTypes([]);
            setClientTypes(result);
        } else {
            setClientTypes([]);
            console.log('Unable to get client type data!');
        }
    };

    const incrementVouchers = () => {
        if (!!fetchNextVouchersPage) {
            let newSearchOptions = _.cloneDeep(voucherSearchOptions);
            newSearchOptions.incrementPageNumber();
            setVoucherSearchOptions(newSearchOptions);
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        const fieldValues = clientSearchTerm.split(',');
        newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
        setClientSearchOptions(newClientSearchOptions);
    };

    const buttonClick = () => {
        console.log('Button Clicked');
    };

    const nextVoucher = () => {
        if ((voucherIndex + 1) < vouchers?.items?.length) {
            setVoucherAccounts([]);
            // getAccountInfo(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            getVoucherAccounts(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            getVoucherInvoices(vouchers?.items[voucherIndex + 1]?.voucherNumber);
            setVoucherIndex(voucherIndex + 1);
            if (voucherIndex + 2 > vouchers?.items?.length) {
                incrementVouchers();
                incrementClients();
            }
        } else {
            alert('No more record!');
        }
    };

    const previousVoucher = () => {
        if (voucherIndex > 0) {
            setVoucherAccounts([]);
            getVoucherAccounts(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            getVoucherInvoices(vouchers?.items[voucherIndex - 1]?.voucherNumber);
            setVoucherIndex(voucherIndex > 0 ? voucherIndex - 1 : voucherIndex);
        }
    };

    const moveToLastVoucher = () => {
        setVoucherIndex(vouchers?.items?.length > 0 ? vouchers?.items?.length - 1 : 0);
    };

    const findProject = (addNewProject: boolean) => {
        if (!!addNewProject) {
            setAddingProject(true);
        } else {
            setAddingProject(false);
            showDialog(DialogList.FIND_PROJECT);
        }
    };

    const displayTitle = () => {
        const title = 'Project Billing Maintenance';

        return title;
    };

    const resetInvoiceTypeValues = (index: number) => {
        let rep = getValues().invoiceTypes;
        let newList = [...rep];

        for (let i = index; i < rep.length - 1; i++) {
            setValue(`invoiceTypes[${i}].id`, rep[i + 1].id);
        }
        setValue(`invoiceTypes[${newList.length - 1}].id`, 0);
        newList.splice(newList.length - 1, 1);

        setSelectedInvoiceTypes(newList);
    };

    const requiredTimesheets = [
        {id: 1, description: `Client's Form`},
        {id: 2, description: 'DLC Form'},
        {id: 3, description: 'Recap Form'}
    ];

    const displayRequiredTimesheets = () => {
        return (
            <div>
                {requiredTimesheets && requiredTimesheets?.map((rt, index) => {
                    return (
                        <div key={rt.id} style={{ whiteSpace: 'nowrap', borderBottom: '1px solid darkgrey', margin: '0px', padding: '0px' }}>
                            <RHFCheckbox
                                name={`requiredTimesheets[${index}]`}
                                register={registerProjectBillingForm}
                                label={rt.description}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    const displayProjectBillingSettings = () => {
        return (
            <>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Project Day Rate'}
                    labelOnLeft={true}
                    name={'dayRate'}
                    register={registerProjectBillingForm}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Mileage Rate:'}
                    labelOnLeft={true}
                    name={'mileageRate'}      
                    register={registerProjectBillingForm}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '80%' }}
                />
                <RHFSelect
                    label="Bill By"
                    name="billBy"
                    options={billByOptions ? billByOptions : [
                        { value: 'G', label: 'Day/Account' },
                        { value: 'Y', label: 'Day/Breakdown' },
                        { value: 'L', label: 'Day/Landman' },
                        { value: 'D', label: 'Day/Project' },
                        { value: 'E', label: 'Day/Subcode' },
                        { value: 'F', label: 'Day/Tract' },
                        { value: 'U', label: 'Day/AltSubcode' },
                        { value: 'K', label: 'Hour/Account' },
                        { value: 'Z', label: 'Hour/Breakdown' },
                        { value: 'M', label: 'Hour/Landman' },
                        { value: 'H', label: 'Hour/Project' },
                        { value: 'I', label: 'Hour/Subcode' },
                        { value: 'J', label: 'Hour/Tract' },
                        { value: 'V', label: 'Hour/AltSubcode' },
                    ]}
                    register={registerProjectBillingForm}
                    errors={errors}
                />
                <RHFInputBox
                    label={'Invoices Due:'}
                    labelOnLeft={true}
                    name={'invoiceDueDays'}      
                    register={register}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '80%' }}
                />
            </div>
            <div style={{display: 'flex', width: '100%' }}>
                <div style={{overflowX: 'hidden', border: 'solid rgb(99, 147, 193) 1px', height: '300px', width: '25%' }}>
                    <RHFLegend
                        title="Invoice Types"
                    />
                    <InvoiceTypeList
                        typeList={invoiceTypeList}
                        selectedTypeList={selectedInvoiceTypes}
                        getValues={() => getValues()}
                        resetValues={(i: number) => resetInvoiceTypeValues(i)}
                        register={registerProjectBillingForm}
                        errors={errors}
                        control={control}
                        tsdiAccounts={tsdiAccounts}
                    />
                </div>
                <div style={{border: 'solid rgb(99, 147, 193) 1px', height: '300px', width: '75%' }}>
                            <FormRow>
                                <div style={{padding: '2px', whiteSpace: 'nowrap', border: 'solid 1px'}}><label>Invoice Factor</label></div>
                                <RHFInputBox name="backupOfficeRate" label="Backup Office Rate" register={registerProjectBillingForm} errors={errors} />
                                <RHFInputBox name="backupOfficePercent" label="Backup Office Percent" register={registerProjectBillingForm} errors={errors} />
                            </FormRow>
                            <FormRow style={{ marginTop: '.5rem' }}>
                                <div>
                                    <RHFCheckbox
                                        name="printBillingPersonnelOnTimeSheet"
                                        register={registerProjectBillingForm}
                                        label={'Print Billing Personnel on Invoice?'}
                                    />
                                </div>
                                <div>
                                    <RHFCheckbox
                                        name="printPreparedDate"
                                        register={registerProjectBillingForm}
                                        label={'Print Prepared Date?'}
                                    />
                                </div>
                                <div>
                                    <RHFCheckbox
                                        name="bopNameOnInvoice"
                                        register={registerProjectBillingForm}
                                        label={'BOP Name on Invoice?'}
                                    />
                                </div>
                                <div>
                                    <RHFCheckbox
                                        name="breakdownOfficeExpenses"
                                        register={registerProjectBillingForm}
                                        label={'Breakdown Office Expenses?'}
                                    />
                                </div>
                            </FormRow>
                            <FormRow style={{ marginTop: '.5rem' }}>
                                <div className="input-resize">
                                    <RHFInputBox
                                        defaultVal="D"
                                        name="invoiceformat"
                                        label="Invoice Format"
                                        register={registerProjectBillingForm}
                                        style={{width: '40%'}}
                                        bodyStyle={{width: '60%', whiteSpace: 'nowrap'}}
                                        errors={errors}
                                    />
                                </div>
                                <div className="input-resize">
                                    <RHFSelect
                                        label={`Invoice Supplement`}
                                        name={`invoiceSupplement`}
                                        register={registerProjectBillingForm}
                                        style={{width: '100%'}}
                                        bodyStyle={{width: '100%', whiteSpace: 'nowrap'}}
                                        options={[
                                            { value: '0', label: 'None' },
                                            { value: '1', label: 'Unit Summary' },
                                            { value: '2', label: 'Client LM Summary' }
                                        ]}
                                    />
                                </div>
                                <div className="input-resize">
                                    <RHFSelect
                                        label="Invoice Period"
                                        name="invoicePeriod"
                                        options={[
                                            { value: 'Weekly', label: 'Weekly' },
                                            { value: 'semiMonthly', label: 'Semi-Monthly' },
                                            { value: 'monthly', label: 'Monthly' },
                                        ]}
                                        bodyStyle={{width: '100%', paddingLeft: '12rem', whiteSpace: 'nowrap'}}
                                        register={registerProjectBillingForm}
                                        errors={errors}
                                    />
                                </div>
                            </FormRow>
                            <FormRow style={{ marginTop: '.5rem' }}>
                                <RHFCheckbox
                                    name="clientFormRequired"
                                    register={register}
                                    label={`Client's Form`}
                                />
                                <RHFCheckbox
                                    name="dlcFormrequired"
                                    register={register}
                                    label={'DLC Form'}
                                />
                                <RHFCheckbox
                                    name="recapFormRequired"
                                    register={register}
                                    label={'Recap'}
                                />
                            </FormRow>
                            <div className="form-row" style={{ marginBottom: '0' }}>
                <div className="flex-gap">
                    <RHFCheckbox
                        name="mealreceiptsrequired"
                        register={register}
                        label={'Meal Receipts Required'}
                    />
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="chargeBackupPersonnel" ref={register} />
                    <label htmlFor="chargeBackupPersonnel">Charge Backup Personnel?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="chargeTsdiOfficeExpenses" ref={register} />
                    <label htmlFor="chargeTsdiOfficeExpenses">Charge Office Expenses?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="flatDayRate" ref={register} />
                    <label htmlFor="flatDayRate">Flat Day Rate (No Expenses)?</label>
                </div>
                {<div className="flex-gap">
                    <input type="checkbox" name="clientLmEmailonInvoice" ref={register} />
                    <label htmlFor="clientLmEmailonInvoice">Client LM E-mail on Invoice?</label>
                </div>}
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <div className="flex-gap">
                    <input type="checkbox" name="mileageDestinationRequired" ref={register} />
                    <label htmlFor="mileageDestinationRequired">Milage Destination Required?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="chargeBackupPersonnelAtCost" ref={register} />
                    <label htmlFor="chargeBackupPersonnelAtCost">Charge Backup Personnel at Cost?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="unityEntryRequired" ref={register} />
                    <label htmlFor="unityEntryRequired">SubCode Required?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="clientProspectNoOnTimeSheet" ref={register} />
                    <label htmlFor="clientProspectNoOnTimeSheet">Enter Client Project No. on Time Sheet?</label>
                </div>
                <div className="flex-gap">
                    <input type="checkbox" name="clientProspectNameOnTimeSheet" ref={register} />
                    <label htmlFor="clientProspectNameOnTimeSheet">Enter Client Project Name on Time Sheet?</label>
                </div>
                </div>
                    </div>
            </div>
                <div className="form-row" style={{ width: '55vw', marginBottom: '0' }}>
                    <div>
                        <FormRow style={{ marginTop: '.5rem' }}>
                            <div style={{padding: '2px', whiteSpace: 'nowrap', border: 'solid 1px'}}><label>Required Time Sheets</label></div>
                        </FormRow>
                    </div>
                </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <div style={{width: '25%', borderTop: '1px solid grey'}}>
                    {displayRequiredTimesheets()}
                </div>
                <div className={'project-billing'} style={{width: '75%', borderTop: '1px solid grey'}}>
                    <div className="project-billing mrg-top mrg-btm">
                        <div className={'project-billing folder-label-border'}>
                            <label className={'project-billing folder-label'} htmlFor="currentInstructions">Billing Instructions</label>
                        </div>
                        <RHFTextArea
                            name="currentInstructions"
                            register={registerProjectBillingForm}
                            errors={errors}
                            style={{resize: 'none', border: 'solid black 1px', width: '100%', height: '11rem'}}
                        />
                    </div>
                </div>
            </div>
            </>
        );
    };

/*     const displayClientBillingInfo = () => {
        return (
            <>
                <RHFLegend title="Client Billing" />
                    <div className="flex-space__between mrg-btm">
                        <FormRow className="flex-space__between" style={{whiteSpace: 'nowrap'}}>
                            <div className="input-resize">
                                <RHFInputBox name="dayRate" label="Default Day Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="mileageRate" label="Mileage Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox name="backupRate" label="Backup Rate" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFInputBox defaultVal="D" name="invoiceformat" label="Invoice Format" register={register} errors={errors} />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Period"
                                    name="invoicePeriod"
                                    options={[
                                        { value: 'Weekly', label: 'Weekly' },
                                        { value: 'semiMonthly', label: 'Semi-Monthly' },
                                        { value: 'monthly', label: 'Monthly' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                    </div>
                    <div>
                        <FormRow className="flex-space__between" style={{whiteSpace: 'nowrap'}}>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Invoice Supplement"
                                    name="invoiceSupplement"
                                    options={[
                                        { value: 'None', label: 'None' },
                                        { value: 'Unit Summary', label: 'Unit Summary' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                            <div className="input-resize">
                                <RHFSelect
                                    label="Bill By"
                                    name="billBy"
                                    options={billByOptions ? billByOptions : [
                                        { value: 'G', label: 'Day/Account' },
                                        { value: 'Y', label: 'Day/Breakdown' },
                                        { value: 'L', label: 'Day/Landman' },
                                        { value: 'D', label: 'Day/Project' },
                                        { value: 'E', label: 'Day/Subcode' },
                                        { value: 'F', label: 'Day/Tract' },
                                        { value: 'U', label: 'Day/AltSubcode' },
                                        { value: 'K', label: 'Hour/Account' },
                                        { value: 'Z', label: 'Hour/Breakdown' },
                                        { value: 'M', label: 'Hour/Landman' },
                                        { value: 'H', label: 'Hour/Project' },
                                        { value: 'I', label: 'Hour/Subcode' },
                                        { value: 'J', label: 'Hour/Tract' },
                                        { value: 'V', label: 'Hour/AltSubcode' },
                                    ]}
                                    register={register}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                    </div>
                    <div style={{ borderTop: '1px solid grey', borderBottom: '1px solid grey' }}>
                        <div className="mrg-top mrg-btm">
                            <RHFTextArea label="Billing Instructions" name="currentInstructions" register={register} errors={errors} />
                        </div>
                    </div>
            </>

        );
    };
 */
    const loadData = () => {
        setProject(undefined);
        getProjectBillingInfo(selectedProject.id);
    };

    const initializeManagerSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const managerSearchOptions = ODataOptions.from(tableConfig);
        managerSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        currentDate.setMonth(new Date().getMonth());
        const endDate = new Date(currentDate.setMonth(currentDate.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        managerSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        managerSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));

        return managerSearchOptions.toString();
    };

    const getManagers = async () => {
        const queryString = initializeManagerSearchSettings();
        let result = await get(`/v1.0/ClientProjectMaintenance/project/managers${queryString}`);

        if (response.ok) {
            setManagers(result);
        } else {
            console.log('Unable to get manager data!!!');
        }
    };

    const onSaveChanges = () => {
        if (isDirtyProjectBillingForm) {
            const payload = new ProjectBilling();
            const projectBillingForm = getValuesProjectBillingForm() as ProjectBilling;
            payload.arInvoiceGrouping = projectBillingForm.arInvoiceGrouping;
            updateProjectBillingInfo(payload);
        }
    };

    const displayHeading2 = () => {
        const title = 'Project Billing Settings';

        return title;
    };

    const renderProjectBillingToggles = () => {
        return (
         <>
            <div style={{width: '100%', borderTop: '1px solid grey', borderBottom: '1px solid grey' }}>
                <div className="form-row" style={{ marginBottom: '0' }}>
                    <div style={{display: 'flex'}}>
                        <RHFCheckbox
                            name="billToOtherProject"
                            label="Bill To Other Project?"
                            register={register}
                            errors={errors}
                        />
                        <RHFInputBox
                            name="projectToBill"
                            label=""
                            register={register}
                            errors={errors}
                        />
                    </div>
                    <RHFCheckbox
                        name="billServicesExpenses"
                        label="Bill Services and Expenses?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="arInvoiceGrouping"
                        label="A/R Invoice Grouping?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="enterClientAFENoOnTimeSheet"
                        label="Enter Client AFE No. on Time Sheet?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="unitTaskEntryRequired"
                        label="Altsubcode Entry Required?"
                        register={register}
                        errors={errors}
                    />
                </div>
                <div className="form-row" style={{ marginBottom: '0' }}>
                    <RHFCheckbox
                        name="doNotExceedProject"
                        label="Do Not Exceed Project?"
                        labelStyle={{whiteSpace: 'nowrap'}}
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="turnkeyBilling"
                        label="Turnkey Billing?"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="roundDays"
                        label="Round Days on Backup/Office"
                        register={register}
                        errors={errors}
                    />
                    <RHFCheckbox
                        name="enterClientAccountNoOnTimeSheet"
                        label="Enter Client Account No on Time Sheet?"
                        register={register}
                        errors={errors}
                    />
                </div>
                <div className="form-row" style={{ marginBottom: '0' }}>
                    <RHFInputBox
                        label={'Total AFE:'}
                        labelOnLeft={true}
                        name={'totalAfe'}      
                        register={register}
                        style={{width: '30%'}}
                        bodyStyle={{width: '30%', whiteSpace: 'nowrap'}}
                    />
                    <RHFCheckbox
                        bodyStyle={{ width: '340px' }}
                        name="printAFEStatusOnInvoiceCoverLetter"
                        label="Print AFE Status on Invoice/Cover Letter?"
                        register={register}
                        errors={errors}
                    />
                    <RHFInputBox
                        name="totalAfeWarningPercentage"
                        label="Total AFE Warning %"
                        register={register}
                        errors={errors}
                        style={{width: '10%'}}
                        bodyStyle={{width: '20%', whiteSpace: 'nowrap'}}
                    />
                    <RHFSelect 
                        label="Billing Frequency"
                        name={`billingFrequency`}
                        options={[
                            { value: '0', label: 'Semi-Monthly' },
                            { value: '1', label: 'Monthly' },
                            { value: '0', label: 'Bi-Monthly' },
                            { value: '1', label: 'Quarterly' },
                            { value: '0', label: 'Semi-Annual' },
                            { value: '1', label: 'Annual' }
                        ]}
                        register={register} 
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '25%' }}
                    />
                </div>
            </div>
         </>   
        );
    };

    return (
        <div>
            <CPNavBar/>
            <ClientProjectSearch
                setSelectedClient={setSelectedClient}
                setSelectedProject={setSelectedProject}
                clients={clients}
                projects={true}
                runQuery={loadData}
                size={6}
            />
            <div id={'ClientBillingPage'} style={{margin: '0 auto', maxWidth: '68vw', display: 'flex', justifyContent: 'center'}}>
                <form id="projectBillingInfoForm" onSubmit={handleSubmit(onSubmit)}>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <div style={{display: 'flex'}}>
                                                <RHFInputBox                                        
                                                    name={'displayProjectNumber'}
                                                    bodyStyle={{width: '30%'}}
                                                    style={{width: '100%'}}
                                                    register={registerSelectedProject}
                                                />
                                                <RHFInputBox
                                                    name={'displayProjectName'}
                                                    bodyStyle={{width: '100%'}}
                                                    style={{width: '100%'}}
                                                    register={registerSelectedProject}
                                                />
                                            </div>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Project"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findProject(false)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Manager"
                                                iconImage={`findLandman.png`}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                                                onClick={() => showDialog(DialogList.FIND_MANAGER)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Project"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findProject(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => buttonClick}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={previousVoucher}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Save Changes"
                                                reactIcon={FaRegSave}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => onSaveChanges()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={nextVoucher}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastVoucher}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing History"
                                                reactIcon={AiOutlineFileText}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Multi-Billing History"
                                                reactIcon={MdHistory}
                                                iconHoverColor="blue"
                                                iconStyle={{fill: 'blue', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Edit Multi-Billing"
                                                reactIcon={FaRegEdit}
                                                iconHoverColor="blue"
                                                iconStyle={{fill: 'blue', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Instruction History"
                                                reactIcon={FaHistory}
                                                iconHoverColor="blue"
                                                iconStyle={{fill: 'violet', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                        </div>                                    
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{maxWidth: '81vw'}}>
                                        {displayProjectBillingSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <div style={{ width: '100%' }}>
                                            {renderProjectBillingToggles()}
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
            <FindManagerDialog
                dialogName={DialogList.FIND_MANAGER}
                hideDialog={hideDialog}
                populateManagerList={getManagers}
                managerList={managers}
            />
            <FindProjectDialog
                billByOptions={billByOptions}
                dialogName={DialogList.FIND_PROJECT} 
                hideDialog={hideDialog}
                setProjectSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vh'}}
                incrementProjects={incrementClients}
                addNewProject={addingProject}
                setSelectedProject={setSelectedProject}
                mileageRate={currentMileageRate}
                onAddNewProject={AddProjectAndHideDialog}
                clientNumber={selectedClient?.clientNumber}
                clientTypes={clientTypes}
            />
            <ReportOptionsDialog
                dialogName={DialogList.REPORT_OPTIONS}
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
                reportTypes={[
                    { value: 0, label: 'Client Name And Address' },
                    { value: 1, label: 'Prospect Information' },
                    { value: 2, label: 'Active Prospect List' },
                    { value: 3, label: 'Active Prospect Mileage' },
                    { value: 4, label: 'Prospect Mileage' },
                    { value: 5, label: 'Prospect by Pay Period ' },
                    { value: 6, label: 'Postage Tally Sheet ' },
                    { value: 7, label: 'Fax Tally Sheet ' },
                    { value: 8, label: 'Supply Tally Sheet' },
                    { value: 9, label: 'Client Landman List' }
                ]}
                parentType={2}
                sortOptions={[
                    { value: 0, label: 'Client Name' },
                    { value: 1, label: 'Client Number' }
                ]}
            />
        </div>
    );
};

export default ManageProjectBilling;


// WEBPACK FOOTER //
// ./src/components/client-project/pages/ManageProjectBilling.tsx